import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const reviews = [{
    name: 'Valentina M.',
    handle: '@valen.candles',
    text: 'Empecé con mucho miedo porque no sabía nada de velas. Hoy, 3 meses después, ya tengo mi propia marca y este mes superé mi sueldo del trabajo que dejé. ¡Gracias!',
    img: 'https://i.pravatar.cc/150?img=44'
  }, {
    name: 'Sofía R.',
    handle: '@sofia_aesthetic',
    text: 'El módulo de Instagram es ORO. Pasé de tener 0 seguidores a vender mi primer lote completo en 48 horas. El packaging que enseñan hace toda la diferencia.',
    img: 'https://i.pravatar.cc/150?img=45'
  }, {
    name: 'Camila T.',
    handle: '@luz.cozy',
    text: 'Por fin un curso que no parece una manualidad barata. Te enseñan a crear una marca premium. Mis clientas aman la presentación.',
    img: 'https://i.pravatar.cc/150?img=49'
  }];
  return <section className="py-24 bg-white" data-id="element-170">
      <div className="max-w-6xl mx-auto px-6" data-id="element-171">
        <FadeIn className="text-center mb-16" data-id="element-172">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-173">Historias Reales</h2>
          <p className="text-xl text-text-brown/70" data-id="element-174">
            Mujeres que ya están viviendo de su emprendimiento.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-175">
          {reviews.map((review, i) => <FadeIn key={i} delay={i * 0.1} direction="up" className="bg-cream p-8 rounded-3xl border border-nude shadow-sm" data-id="element-176">
              <div className="flex text-gold-soft mb-4" data-id="element-177">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-178" />)}
              </div>
              <p className="text-text-brown/90 mb-6 italic leading-relaxed" data-id="element-179">
                "{review.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-180">
                <img src={review.img} alt={review.name} className="w-12 h-12 rounded-full object-cover" data-id="element-181" />
                <div data-id="element-182">
                  <h4 className="font-bold text-text-dark" data-id="element-183">{review.name}</h4>
                  <span className="text-sm text-text-brown/60" data-id="element-184">
                    {review.handle}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};